module.exports = __webpack_public_path__ + "assets/img/6cfbb3aacf304be1a12bed312073da3f.webp";